import React, {useEffect, useRef} from 'react';
import * as THREE from 'three';
const ThreeBackground = () => {
    const mountRef = useRef(null);

    useEffect(() => {
        const mount = mountRef.current;

        //Initialize scene, camera and renderer
        function randomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        }

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(75, mount.clientWidth / mount.clientHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({ alpha: false });

        renderer.setSize(mount.clientWidth, mount.clientHeight);
        // renderer.setClearColorHex( 0xffffff, 1 );
        mount.appendChild(renderer.domElement);

        let spheres = [];
        for (let i = 1; i < 300; i++) {
            let geometry = new THREE.SphereGeometry(0.04 * randomArbitrary(0.5, 1), 6, 6);
            let material = new THREE.MeshBasicMaterial({
                color: new THREE.Color(1, randomArbitrary(190, 220) / 255, Math.round(Math.random()))
            });

            let sphere = new THREE.Mesh(geometry, material);
            scene.add(sphere);
            spheres.push(sphere);
            sphere.position.setFromSpherical(new THREE.Spherical(5 + 5 * Math.random(), 2 * Math.PI * Math.random(), 2 * Math.PI * Math.random()))
        }
        scene.rotation.x = 0.2;
        scene.rotation.z = 0.6;
        camera.position.z = 5;

        var animate = function() {
            requestAnimationFrame(animate);
            scene.rotation.y += 0.001;
            scene.rotation.z -= 0.001;

            renderer.render(scene, camera);
        };

        animate();

        // Handle window resize
        const handleResize = () => {
            renderer.setSize(mount.clientWidth, mount.clientHeight);
            camera.aspect = mount.clientWidth / mount.clientHeight;
            camera.updateProjectionMatrix();
        };

        window.addEventListener('resize', handleResize);

        // Clean up on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            mount.removeChild(renderer.domElement);
        };
    }, []);

    return <div ref={mountRef} style={{position:'absolute',top:0, left:0, width: '100vw', height:'100vh', overflow:'hidden'}}/>;
};

export default ThreeBackground;



